const validPartnerGuids = new Set(["56c68053-81f0-4f78-9adf-f21730f239d7","8de5776c-bf38-4ca8-9593-af30c191efc3"])
export default  validPartnerGuids;